import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchIndustry } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { ArrowLeft, Check } from "lucide-react";

export default function IndustryDetailPage() {
  const { slug } = useParams();
  const [industry, setIndustry] = useState(null);

  useEffect(() => {
    fetchIndustry(slug).then(setIndustry).catch(() => setIndustry(null));
  }, [slug]);

  if (!industry) {
    return (
      <div className="mx-auto max-w-[1200px] px-5 py-20 text-center">
        <h2 className="font-display text-3xl">Laden...</h2>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="industry-detail-page">
      <div className="relative h-[50vh] min-h-[360px] overflow-hidden">
        <img src={industry.image} alt={industry.name} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/70" />
        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto w-full max-w-[1400px] px-5 pb-10 lg:px-10">
            <Link
              to="/industries"
              className="mb-6 inline-flex items-center gap-2 text-sm text-white/85 hover:text-white"
              data-testid="industries-back-link"
            >
              <ArrowLeft size={14} /> Alle industrieën
            </Link>
            <h1 className="font-display text-5xl font-black uppercase tracking-wide text-white drop-shadow-lg sm:text-6xl lg:text-7xl">
              {industry.name_nl || industry.name}
            </h1>
            <p className="mt-4 max-w-2xl text-lg text-white/95 drop-shadow">{industry.description}</p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 py-12 lg:px-10">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {(industry.highlights || []).map((h, i) => (
            <div
              key={i}
              className="flex items-start gap-3 rounded-md border border-nibro-sage/40 bg-nibro-sage-pale p-4"
            >
              <Check size={16} className="mt-1 flex-shrink-0 text-nibro-sage-dark" />
              <div className="text-sm text-zinc-800">{h}</div>
            </div>
          ))}
        </div>

        {industry.recommended_products && industry.recommended_products.length > 0 && (
          <div className="mt-16">
            <div className="nibro-frame mb-10">
              <h2 className="nibro-section-title">AANBEVOLEN VOOR {(industry.name_nl || industry.name).toUpperCase()}</h2>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {industry.recommended_products.map((p) => (
                <ProductCard key={p.id} p={p} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
